import Root from './root.svelte'
import Head from './head.svelte'
import Header from './header.svelte'
import Body from './body.svelte'
import Row from './row.svelte'
import Cell from './cell.svelte'
import SelectedActions from './selected-actions.svelte'
import Empty from '../general/empty.svelte'
import FilterBar from './filter-bar.svelte'
import Pagination from './pagination.svelte'
import CheckboxHeader from './checkbox-header.svelte'
import SelectionDropdownCell from './selection-dropdown-cell.svelte'

const Table = {
  Root,
  Head,
  Header,
  Body,
  Row,
  Cell,
  SelectedActions,
  Empty,
  FilterBar,
  Pagination,
  CheckboxHeader,
  SelectionDropdownCell,
}

export default Table